var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-result',{attrs:{"title":"404","subTitle":"对不起，您访问的页面不存在。"}},[_c('template',{slot:"icon"},[_c('img',{attrs:{"src":"/404.png","alt":""}})]),_c('template',{slot:"extra"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":_vm.toHome}},[_vm._v(" 返回首页 ")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }